import React from "react";
import useFetchData from "../../common/api/useFetchData";

export function DateTime({ endpoint }: { endpoint?: string }) {
	if (!endpoint) {
		return null;
	}

	const { data } = useFetchData({ endpoint });

	if (!data) {
		return null;
	}

	const date = data && <span>{data.localDate}</span>;
	const time = data && <span>{data.localTime}</span>;

	return (
		<ul className="date-time-info">
			<li>{date} Current Local Date</li>
			<li>{time} Current Local Time</li>
		</ul>
	);
}
